'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitUnfollowSeller = exports.submitFollowSeller = exports.isSellerFollowed = exports.getFollowedSellerIds = exports.UNFOLLOW_SELLER_SUCCESS = exports.UNFOLLOW_SELLER_REQUEST = exports.UNFOLLOW_SELLER_FAIL = exports.FOLLOW_SELLER_SUCCESS = exports.FOLLOW_SELLER_REQUEST = exports.FOLLOW_SELLER_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;

var _user = require('./user');

var _analytics = require('./analytics');

var _api = require('../api');

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('./config');

var _login = require('./login');

var _passwordReset = require('./passwordReset');

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var FOLLOW_SELLER_FAIL = exports.FOLLOW_SELLER_FAIL = 'la/user/followSeller/FAIL';
var FOLLOW_SELLER_REQUEST = exports.FOLLOW_SELLER_REQUEST = 'la/user/followSeller/REQUEST';
var FOLLOW_SELLER_SUCCESS = exports.FOLLOW_SELLER_SUCCESS = 'la/user/followSeller/SUCCESS';

var UNFOLLOW_SELLER_FAIL = exports.UNFOLLOW_SELLER_FAIL = 'la/user/unfollowSeller/FAIL';
var UNFOLLOW_SELLER_REQUEST = exports.UNFOLLOW_SELLER_REQUEST = 'la/user/unfollowSeller/REQUEST';
var UNFOLLOW_SELLER_SUCCESS = exports.UNFOLLOW_SELLER_SUCCESS = 'la/user/unfollowSeller/SUCCESS';

// reducer
var DEFAULT_STATE = [];

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case FOLLOW_SELLER_SUCCESS:
            return (0, _union2.default)(state, [action.payload]);

        case _user.LOAD_BIDDER_DATA_SUCCESS:
            return [].concat((0, _toConsumableArray3.default)(action.payload.followedSellers));

        case _user.LOG_OUT_BIDDER:
            return [];

        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            return [].concat((0, _toConsumableArray3.default)(action.payload.followedSellers));

        case UNFOLLOW_SELLER_SUCCESS:
            return (0, _difference2.default)(state, [action.payload]);

        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.followSeller;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var getFollowedSellerIds = exports.getFollowedSellerIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return [].concat((0, _toConsumableArray3.default)(state));
});

var isSellerFollowed = exports.isSellerFollowed = (0, _reselect.createSelector)([stateSelector, idSelector], function (state, id) {
    return state.indexOf(id) >= 0;
});

/* ACTION CREATORS */
var submitFollowSeller = exports.submitFollowSeller = function submitFollowSeller(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: FOLLOW_SELLER_REQUEST
                            });
                            _context.next = 7;
                            return _api.Seller.postFollow({ authToken: authToken, deployment: deployment, sellerId: sellerId });

                        case 7:
                            dispatch({
                                meta: (0, _analytics.getFollowSellerAnalytics)(sellerId),
                                payload: sellerId,
                                type: FOLLOW_SELLER_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: FOLLOW_SELLER_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var submitUnfollowSeller = exports.submitUnfollowSeller = function submitUnfollowSeller(sellerId) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: UNFOLLOW_SELLER_REQUEST
                            });
                            _context2.next = 7;
                            return _api.Seller.postUnfollow({ authToken: authToken, deployment: deployment, sellerId: sellerId });

                        case 7:
                            dispatch({
                                meta: (0, _analytics.getUnfollowSellerAnalytics)(sellerId),
                                payload: sellerId,
                                type: UNFOLLOW_SELLER_SUCCESS
                            });
                            _context2.next = 13;
                            break;

                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context2.t0,
                                type: UNFOLLOW_SELLER_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[0, 10]]);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/followSeller.js
// module id = /9SA
// module chunks = 60